module.exports = __webpack_public_path__ + "static/media/news.63d6d55f.png";